import React from "react";
import ActionButtons from "../ActionButtons";
import { useOnlinePaymentsConfig } from "../../Context/ValidationContext";

interface ProviderConfigActionsProps {
  showReview: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onDelete: () => void;
  onPrimaryAction: () => void;
}

function getButtonText(
  internalReadOnly: boolean,
  showReview: boolean,
  mode: "ADD" | "EDIT",
): string {
  if (internalReadOnly) {
    return "Fechar";
  }
  if (showReview) {
    return "Salvar";
  }
  return mode === "EDIT" ? "Salvar" : "Adicionar";
}

function getLoadingText(mode: "ADD" | "EDIT"): string {
  return mode === "EDIT" ? "Salvando..." : "Adicionando...";
}

function ProviderConfigActions({
  showReview,
  onEdit,
  onCancel,
  onDelete,
  onPrimaryAction,
}: ProviderConfigActionsProps) {
  const { mode, isLoading, internalReadOnly } = useOnlinePaymentsConfig();

  const buttonText = getButtonText(internalReadOnly, showReview, mode);
  const loadingText = getLoadingText(mode);

  return (
    <ActionButtons
      mode={mode}
      isLoading={isLoading}
      internalReadOnly={internalReadOnly}
      showReview={showReview}
      onEdit={onEdit}
      onCancel={onCancel}
      onDelete={onDelete}
      onPrimaryAction={onPrimaryAction}
      getButtonText={() => buttonText}
      getLoadingText={() => loadingText}
    />
  );
}

export default ProviderConfigActions;
